// extracted by mini-css-extract-plugin
export default {"fly":"Funding_fly__PVoT4"};